export default "__VITE_ASSET__BXmih2zN__"